import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowUpRight, Quote } from 'lucide-react';
const reviews = [{
  name: 'Sarah M.',
  suburb: 'Karrinyup',
  date: 'October 2025',
  quote: 'Fixed pricing, no hidden costs and a spotless ducted installation. The system has performed reliably through summer.',
  system: 'Ducted reverse cycle'
}, {
  name: 'David T.',
  suburb: 'Balcatta',
  date: 'September 2025',
  quote: 'The on-site assessment was more thorough than the other quotes, including proper load calculations for the home.',
  system: 'Mitsubishi split'
}, {
  name: 'Emma L.',
  suburb: 'Duncraig',
  date: 'August 2025',
  quote: 'Honest advice from the first call. The team recommended the right size, installed cleanly and explained every control.',
  system: '5-zone ducted'
}, {
  name: 'James W.',
  suburb: 'Hillarys',
  date: 'August 2025',
  quote: 'The replacement was assessed on site, completed in a day and the home was left cleaner than before the work began.',
  system: 'Daikin split'
}, {
  name: 'Priya K.',
  suburb: 'Subiaco',
  date: 'July 2025',
  quote: 'Everything was explained in plain English, including system choices, finance and what would happen on installation day.',
  system: 'Multi-head split'
}, {
  name: 'Tom B.',
  suburb: 'Joondalup',
  date: 'June 2025',
  quote: 'A small drainage issue after installation was handled promptly under the workmanship guarantee, with no extra invoice.',
  system: 'Ducted with iZone'
}];
export function Reviews() {
  return <section id="reviews" className="bg-paper py-20 md:py-28 scroll-mt-24" data-id="element-622" data-mp="30cai3bwt0k49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-623" data-mp="2wca41sdmaaxq">
        <div className="grid lg:grid-cols-12 gap-10 mb-12" data-id="element-624" data-mp="2w9nw3rmtdtez">
          <div className="lg:col-span-7" data-id="element-625" data-mp="3suofxbi5463c">
            <div className="kicker mb-3" data-id="element-626" data-mp="3svhh7wyby3e3">Customer feedback</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-627" data-mp="3o24vbul1cap1">
              5.0 from 75 Google reviews.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-8 lg:border-l border-stone-300 flex flex-col justify-end" data-id="element-628" data-mp="1r3xsj20vfx8e">
            <a href="https://www.google.com/search?q=langler+air+perth+reviews" target="_blank" rel="noopener noreferrer" className="group inline-flex flex-col items-start" data-id="element-629" data-mp="1cfb1w45snj1v">
              <div className="flex items-center gap-3 mb-3" data-id="element-630" data-mp="18dpvn1nrm30n">
                <div className="flex" data-id="element-631" data-mp="18falidz4wxs6">
                  {[0, 1, 2, 3, 4].map(i => <Star key={i} size={22} className="fill-amber-400 text-amber-400" data-id="element-632" data-mp="ths1tq1bdarl" />)}
                </div>
                <span className="font-display text-3xl font-extrabold tabular-nums" data-id="element-633" data-mp="ygl5yrupnpf3">5.0</span>
              </div>
              <p className="text-base text-stone-700 mb-3 max-w-sm" data-id="element-634" data-mp="2nvj7yfkfpcia">See the full customer feedback and current rating on Google.</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-bold text-brand group-hover:gap-2.5 transition-all" data-id="element-635" data-mp="h6h9js14wn3j">
                See all 75 on Google <ArrowUpRight size={15} data-id="element-636" data-mp="c8peip570kv4" />
              </span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-637" data-mp="qxvck9sao51f">
          {reviews.map((review, i) => <motion.article key={review.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.06
        }} className="bg-white rounded-2xl p-7 border border-stone-200 shadow-sm flex flex-col" data-id="element-638" data-mp="m3hfm2xzhpun" data-mpi={i}>
              <Quote size={24} className="text-brand mb-4" strokeWidth={1.5} data-id="element-639" data-mp="14xd4gy0vzyf0" />
              <p className="text-base leading-relaxed text-ink-900 flex-grow mb-6" data-id="element-640" data-mp="3blq8tf578at7">{review.quote}</p>
              <div className="pt-5 border-t border-stone-200 flex items-center justify-between" data-id="element-641" data-mp="36ogk61pmw36f">
                <div data-id="element-642" data-mp="383kazw7pjlzk">
                  <div className="font-bold text-ink-900 text-sm" data-id="element-643" data-mp="3842endwp92hi">{review.name}</div>
                  <div className="text-xs text-stone-500 mt-0.5" data-id="element-644" data-mp="3d2dq1t2n7l1u">{review.suburb} · {review.date}</div>
                </div>
                <div className="flex flex-col items-end gap-1" data-id="element-645" data-mp="3i3jirqwaz8bd">
                  <div className="flex" data-id="element-646" data-mp="3n0tibzdep0cx">{[0, 1, 2, 3, 4].map(s => <Star key={s} size={11} className="fill-amber-400 text-amber-400" data-id="element-647" data-mp="3mziey0nvhumc" />)}</div>
                  <span className="text-[10px] font-semibold text-stone-500 uppercase tracking-wider" data-id="element-648" data-mp="2pbzx80c8hi67">Google</span>
                </div>
              </div>
              <div className="mt-3 inline-flex items-center px-2 h-5 rounded-full bg-stone-100 text-[11px] font-medium text-stone-700 w-fit" data-id="element-649" data-mp="2zb8yle9fhz2l">{review.system}</div>
            </motion.article>)}
        </div>
        <p className="mt-10 text-center text-xs text-stone-500" data-id="element-650" data-mp="26mtlix9uxqtw">Customer feedback above is summarised for clarity. View the original reviews on Google.</p>
      </div>
    </section>;
}